import { DEFAULT_SELECTED_OPTIONS } from './constants'

const normalize = {
  brands(brands) {
    return brands.map(String)
  },
  size_types(size_types) {
    return Object.keys(size_types).reduce((normalizedSizeTypes, sizeType) => {
      normalizedSizeTypes[sizeType] = size_types[sizeType].map(String)
      return normalizedSizeTypes
    }, {})
  },
  price_min(value) {
    return typeof value === 'number' && !isNaN(value) ? value : null
  },
  price_max(value) {
    return typeof value === 'number' && !isNaN(value) ? value : null
  },
  seller_segmentation(value) {
    const validValues = ['power_seller', 'seller_highlighted']

    return validValues.includes(value) ? value : null
  }
}

export default function normalizeOptionsFromURL(options, root) {
  return Object.keys(options).reduce((normalizedOptions, key) => {
    const defaults = root ? root : DEFAULT_SELECTED_OPTIONS

    // Arrays in the querystring are represented by the repetition
    // of the same param key (eg. b=zara&b=farm&b=forever-21). If
    // one option that should be an array only has one value (eg. b=zara),
    // we need to take it and encapsulate it on an array, because the parser
    // can't know that it is supposed to be an array and not a string as
    // some other params.
    if (
      defaults[key] &&
      defaults[key].constructor === Array &&
      normalizedOptions[key] &&
      normalizedOptions[key].constructor !== Array
    ) {
      normalizedOptions[key] = [normalizedOptions[key]]
    }

    // If the value is supposed to be an object we need to
    // recursively normalize its properties.
    if (defaults[key] && defaults[key].constructor === Object) {
      normalizedOptions[key] = normalizeOptionsFromURL(normalizedOptions[key], defaults[key])
    }

    if (normalize[key]) {
      normalizedOptions[key] = normalize[key](normalizedOptions[key])
    }

    return normalizedOptions
  }, options)
}
